@if (list && list.length > 0) {
  <ul #content>
    @for (item of list; track item; let i = $index; let last = $last) {
      <li
        class="list__item {{ addonClass }}"
			[ngClass]="{
            'list__item--highlighted': item.highlighted,
            'overflow-hidden': type === 'news'
        }"
        >
        <div class="list__item__wrapper">
          <div class="list__item__titlebox">
            <div [class]="type === 'news' ? 'col-8 xs-hide' : 'col-grow'">
              @if (item.head) {
                <div class="list__item__head">
                  {{ returnEntityString(item.head) }}
                </div>
              }
              <div class="flex flex-center flex-wrap list__item__titleWrapper">
                <a
                  [routerLink]="item?.url?.path || item.url || item.path"
                  attr.id="listItem-{{ i }}"
                  class="list__item__title"
                  [attr.data-test-id]="'list-item-link-' + ((item?.url?.path || item?.url || item?.path) | slugify)"
                  >
                  <h2>{{ item.title }}</h2>
                </a>
              </div>
              @if ((item.author || item.created) && type === 'news') {
                <div
                  class="author"
                  [attr.aria-current]="isCurrentDate(item.created * 1000) ? 'date' : undefined"
                  >
                  {{ item.author || item.fieldAuthor }} {{ item.created*1000 |
                  date:"dd.MM.yyyy" }}
                </div>
              }
              @if (item.tags) {
                <div class="tags">
                  <labels [data]="item.tags" type="default"></labels>
                </div>
              }
              @if (item.shortDescription) {
                <div class="description">
                  {{ item.shortDescription | ellipsis:320 }}
                </div>
              }
              @if (item.fixedLabel?.length) {
                <labels
                  [data]="item.fixedLabel"
                  type="orange"
                  >
                </labels>
              }
            </div>
            @if (compare) {
              <div class="col--compare sm-hide">
                <compare [id]="item.nid" [sessionStorageKey]="compare"></compare>
              </div>
            }
            @if (item.image && !item.video) {
              <div
                class="col-4 xs-12 pointer list__item__image"
                >
                @if ((item.image | arrayFirst); as Image) {
                  <img
                    [class.lastImg]="last"
                    src="{{ Image.derivative?.url || Image.url }}"
                    alt=""
                    width="100%"
                    height="100%"
                    [routerLink]="item?.url?.path || item.url || item.path"
                    />
                  }
                </div>
              }
              @if (item.video && item.video.videoId) {
                @if (!clickedVideos[i]) {
                  <button
                    class="col-4 xs-12 pointer list-item__video-button"
                    (click)="clickedVideos[i] = true"
                    attr.aria-label="{{ 'generic.youtube_video' | translate }}: {{ item.video.videoDescription }}"
                    >
                    <div class="list__item__video__thumbnail">
                      @if (item.video.videoThumbnail) {
                        <img
                          [class.lastImg]="last"
                          src="{{ item.video.videoThumbnail }}"
                          width="100%"
                          alt=""
                          />
                      }
                      <i
                        class="icon youtube-play"
                      ></i>
                      <div class="triangle" aria-hidden="true"></div>
                    </div>
                  </button>
                }
                @if (clickedVideos[i]) {
                  <div class="col-4 xs-12 list__item__video">
                    <div class="aspect">
                      <iframe
                        attr.aria-label="{{ 'generic.youtube_video' | translate }}"
                        [src]="item.video.videoEmbed +'?autoplay=1&mute=1' | iframe "
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                      ></iframe>
                    </div>
                  </div>
                }
              }
            </div>
            @if (type === 'news') {
              <div class="xs-show col-12 resp-fields">
                <a
                  [routerLink]="item.url?.path || item.url || item.path"
                  class="mb-0"
                  [attr.data-test-id]="'list-item-link-' + ((item?.url?.path || item?.url || item?.path) | slugify)"
                  >
                  <h3 class="title">{{ item.title }}</h3>
                </a>
                <div class="author" [attr.aria-current]="isCurrentDate(item.created * 1000) ? 'date' : undefined">
                  {{ item.author || item.fieldAuthor }} {{ item.created*1000 |
                  date:"dd.MM.yyyy" }}
                </div>
              </div>
            }
            @if (item.sidebar?.length && item.sidebar?.[0]?.fieldOskaField?.length) {
              <div class="inline__items sm-hide">
                @for (oskaField of item.sidebar[0].fieldOskaField; track oskaField; let ind = $index; let last = $last) {
                  @if (ind < 2 && oskaField) {
                    @if (oskaField.title && ind !== 0) {
                      <span
                        aria-hidden="true"
                        class="bar"
                        >|</span
                        >
                      }
                      <div class="item item--inline">
                        <a
                          [href]="oskaField.path"
                          tabindex="0"
                          attr.aria-label="{{ 'oska.title_field' | translate }} {{ oskaField.title }}"
                          [attr.data-test-id]="'list-item-oska-link-' + (oskaField?.path | slugify)"
                          >{{ oskaField.title }}</a
                          >
                        </div>
                      }
                    }
                  </div>
                }
                @if (type === 'mainProfession') {
                  <div class="sm-show inline__items">
                    @if (item.fillingBar) {
                      @if (item.fillingBar?.length && item.fillingBar[0].value
                        && item.fillingBar[0].value > 0 && item.fillingBar[0].value < 6) {
                        <span class="item item--expanded"
                          >{{ 'oska.competition' | translate | ucfirst }}:
                          <span class="dark"
                            >{{ getCompetitionLabel(item.fillingBar[0].value) | translate
                            }}</span
                            >
                          </span>
                        }
                        @if (item.indicator?.length) {
                          @for (elem of indicatorValues(item.indicator); track elem; let ind = $index) {
                            @if (elem.oskaId && elem.oskaId == 1) {
                              <span class="item item--expanded"
                                >{{ 'oska.fieldNumberEmployed' | translate }}:
                                <span class="dark">{{ elem.value | localeNumber }}</span>
                              </span>
                            }
                          }
                        }
                      }
                    </div>
                  }
                  @if (type === 'school') {
                    <div
                      class="sm-show inline__items inline__items--floating"
                      >
                      @for (fieldName of footerFields[type]; track fieldName; let i = $index) {
                        @if (item[fieldName]) {
                          @if (i>0) {
                            <span role="presentation" class="bar">|</span>
                          }
                          @if (fieldName === 'webpage' && item[fieldName]) {
                            <span
                              class="item"
                              >
                              <a
                                attr.aria-label="{{ 'event.webpage' | translate }} {{ item[fieldName] | removeProtocol }}"
                                href="{{ item[fieldName] | url }}"
                                target="_blank"
                                [attr.data-test-id]="'list-item-webpage-link-' + (item?.[fieldName] | url | slugify)"
                                >{{ item[fieldName] | removeProtocol }}</a
                                >
                              </span>
                            }
                            @if (fieldName === 'email') {
                              <span class="item">
                                <a
                                  attr.aria-label="{{'event.email' | translate}} {{ item[fieldName] }}"
                                  href="mailto:{{ item[fieldName]}}"
                                  [attr.data-test-id]="'list-item-email-link-' + (item?.[fieldName] | slugify)"
                                  >{{ item[fieldName]}}</a
                                  >
                                </span>
                              }
                              @if (fieldName === 'phone') {
                                <span class="item">
                                  <a
                                    attr.aria-label="{{'event.phone' | translate}} {{ item[fieldName] }}"
                                    href="tel:{{ item[fieldName] }}"
                                    [attr.data-test-id]="'list-item-phone-link-' + (item?.[fieldName] | slugify)"
                                    >{{ item[fieldName] }}</a
                                    >
                                  </span>
                                }
                              }
                            }
                          </div>
                        }
                        @if (type !== 'news') {
                          <div
                            [class]="type === 'school' || type === 'mainProfession' ? 'inline__items sm-hide' : 'inline__items'"
                            >
                            @for (fieldName of footerFields[type]; track fieldName; let i = $index) {
                              @if (item[fieldName]?.length) {
                                @if (i>0) {
                                  <span role="presentation" class="bar">|</span>
                                }
                                @if (fieldName === 'duration') {
                                  <span class="item"
                                    >{{ item.duration | monthsToYears }}</span
                                    >
                                  }
                                  @if (fieldName === 'studyProgrammeLevel' ||
                                    fieldName === 'fieldSchoolName') {
                                    <span
                                      class="item"
                                      >{{ item[fieldName] }}</span
                                      >
                                    }
                                    @if (fieldName === 'address' || fieldName === 'fieldSchoolLocation') {
                                      <span class="item"
                                        >{{ item[fieldName]?.[0]?.fieldAddress }}</span
                                        >
                                      }
                                      @if (fieldName === 'educationalInstitution') {
                                        <span class="item"
                                          >{{ item[fieldName]?.[0]?.title }}</span
                                          >
                                        }
                                        @if (fieldName === 'teachingLanguage') {
                                          @if (isArray((item[fieldName]))) {
                                            <span class="item">
                                              @for (item of (item[fieldName]); track item; let i = $index) {
                                                <span>
                                                  @if (i > 0) {
                                                    <span>, </span>
                                                  }
                                                  @if (i === 0) {
                                                    <span>{{ item | ucfirst }}</span>
                                                  }
                                                  @if (i !== 0) {
                                                    <span>{{ item }}</span>
                                                  }
                                                </span>
                                              }
                                            </span>
                                          }
                                          @if (!isArray(item[fieldName])) {
                                            <span class="item">
                                              {{ item[fieldName] | ucfirst }}
                                            </span>
                                          }
                                        }
                                        @if (fieldName === 'webpage' && item[fieldName]) {
                                          <span
                                            class="item"
                                            >
                                            <a
                                              attr.aria-label="{{'event.webpage' | translate}} {{ item[fieldName] | removeProtocol }}"
                                              href="{{ item[fieldName] | url }}"
                                              target="_blank"
                                              [attr.data-test-id]="'list-item-webpage-link-' + (item?.[fieldName] | url | slugify)"
                                              >{{ item[fieldName] | removeProtocol }}</a
                                              >
                                            </span>
                                          }
                                          @if (fieldName === 'email') {
                                            <span class="item">
                                              <a
                                                attr.aria-label="{{'event.email' | translate}} {{ item[fieldName]}}"
                                                href="mailto:{{ item[fieldName]}}"
                                                [attr.data-test-id]="'list-item-email-link-' + (item?.[fieldName] | slugify)"
                                                >{{ item[fieldName]}}</a
                                                >
                                              </span>
                                            }
                                            @if (fieldName === 'phone') {
                                              <span class="item">
                                                <a
                                                  attr.aria-label="{{'event.phone' | translate}} {{ item[fieldName]}}"
                                                  href="tel:{{ item[fieldName]}}"
                                                  [attr.data-test-id]="'list-item-phone-link-' + (item?.[fieldName] | slugify)"
                                                  >{{ item[fieldName]}}</a
                                                  >
                                                </span>
                                              }
                                              @if (fieldName === 'fillingBar' && !item.fieldProfession) {
                                                @if ((item[fieldName]?.length && item[fieldName][0]?.value) || item.indicator?.length) {
                                                  @if (item[fieldName][0].value > 0 && item[fieldName][0].value < 6) {
                                                    <span class="item"
                                                      >{{ 'oska.competition' | translate | ucfirst }}:
                                                      <span class="dark"
                                                        >{{ getCompetitionLabel(item[fieldName][0].value) |
                                                        translate }}</span
                                                        ></span
                                                        >
                                                      }
                                                      @if (item.indicator?.length) {
                                                        @for (elem of indicatorValues(item.indicator); track elem; let ind = $index) {
                                                          @if (elem.oskaId) {
                                                            @if ((
                                                              item[fieldName]?.length && item[fieldName][0]?.value &&
                                                              item[fieldName][0].value > 0 && item[fieldName][0].value < 6
                                                              ) || ind === 1) {
                                                              <span
                                                                class="bar"
                                                                >|</span
                                                                >
                                                              }
                                                              <span class="item"
                                                                >{{ elem.oskaId == 1 ? ('oska.fieldNumberEmployed' |
                                                                translate) : (elem.oskaIndicator | ucfirst) }}:
                                                                @if (elem.oskaId == 1) {
                                                                  <span class="dark"
                                                                    >{{ elem.value | localeNumber }}</span
                                                                    >
                                                                  }
                                                                  @if (elem.oskaId == 3) {
                                                                    <span class="dark"
                                                                      >{{ elem.value | currency:"EUR" }}
                                                                    </span>
                                                                  }
                                                                </span>
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                </div>
                                              }
                                            </div>
                                            @if (item?.fieldPictogram?.[0] && item.highlighted) {
                                              <div
                                                class="list__item__picto-wrapper"
                                                >
                                                <picto
                                                  tabindex="-1"
                                                  aria-hidden="true"
                                                  [img]="item.fieldPictogram[0].url"
                                                ></picto>
                                              </div>
                                            }
                                          </li>
                                        }
                                        <!--/list repeat-->
                                      </ul>
                                    }

                                    @if (compare) {
                                      <htm-modal
                                        id="compare"
                                        [modalTitle]="translationsPerType[compare].title | translate"
                                        size="medium"
                                        >
                                        <ng-template id="compare">
                                          <div
                                            innerHTML="{{ translationsPerType[compare].content | translate }}"
                                          ></div>
                                        </ng-template>
                                      </htm-modal>
                                    }

                                    <alerts global id="compare"></alerts>
